import { render, staticRenderFns } from "./artifacts_block.vue?vue&type=template&id=09813692&"
import script from "./artifacts_block.vue?vue&type=script&lang=js&"
export * from "./artifacts_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "artifacts_block.vue"
export default component.exports